import React from "react";
import { useState,useEffect } from "react";
import ReactApexChart from "react-apexcharts";




const LineColumnArea = (props) => {

  
const store = props.store;
const[loaded, setLoaded] = useState(false)

const [allOrders, setAllorders]  = useState([]);
const [deliveredOrders, setDeliveredorders] = useState([])
const [cancelledOrders, setCancelledorders] = useState([])

useEffect(()=>{
  const fetchAllorders =async()=>{
    const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/orders-per-month?store=${store}`)
    const data  = await res.json();
    setAllorders(data)
    setLoaded(true)
  }

  const fetchAlldeliveredorders =async()=>{
    const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/orders-delivered-per-month?store=${store}`)
    const data  = await res.json();
    setDeliveredorders(data)

  }
  const fetchAllcancelledorders =async()=>{
    const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/orders-cancelled-per-month?store=${store}`)
    const data  = await res.json();
    setCancelledorders(data)

  }


  if(store){
    fetchAllorders()
    fetchAlldeliveredorders();
    fetchAllcancelledorders();
  }

},[store])

  const LineColumnAreaData = {
  series: [
    {
      name: "All orders",
      type: "column",
      data: allOrders,
    },
    {
      name: "Delivered orders",
      type: "area",
      data: deliveredOrders,
    },
    {
      name: "Cancelled orders",
      type: "line",
      data: cancelledOrders,
    },
  ],
  options: {
    chart: {
      stacked: false,
      toolbar: {
        show: false,
      },
    },
    stroke: {
      width: [0, 0.5, 1],
      curve: "smooth",
      dashArray: [0, 8, 5]
    },
    plotOptions: {
      bar: {
        columnWidth: "18%",
      },
    },
    colors: ["#0ab39c", "blue", "rgb(251, 77, 83)"],

    fill: {
      opacity: [0.85, 0.25, 1],
      gradient: {
        inverseColors: false,
        shade: "light",
        type: "vertical",
        opacityFrom: 0.85,
        opacityTo: 0.55,
        stops: [0, 100, 100, 100],
      },
    },
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    markers: {
      size: 0,
    },
    legend: {
      offsetY: 11,
    },
    xaxis: {
      type: "month",
    },
    yaxis: {
      title: {
        text: "orders",
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: function (y) {
          if (typeof y !== "undefined") {
            return y.toFixed(0) + " orders"
          }
          return y
        },
      },
    },
    grid: {
      borderColor: "#f1f1f1",
    },
  },
}
  return(
    <React.Fragment>
    {!loaded &&
    <p>Fetching data...</p>
    }
    {loaded &&
      <ReactApexChart
          options={LineColumnAreaData.options}
          series={LineColumnAreaData.series}
          type="line"
          height="350"
          stacked= "false"
          className="apex-charts"
        />
    }
       
      </React.Fragment>
  )
}

export default LineColumnArea;